<template>
	<van-tabbar v-model="activeA" active-color="#e4485e">
  <van-tabbar-item icon="home-o" :to="{name: 'Index'}">首页</van-tabbar-item>
  <van-tabbar-item icon="friends-o" :to="{name: 'DatiRank'}">排行榜</van-tabbar-item>
  <van-tabbar-item icon="setting-o" :to="{name: 'DatiRules'}">活动说明</van-tabbar-item>
  <van-tabbar-item icon="setting-o" :to="{name: 'DatiChoujiang'}">抽奖</van-tabbar-item>
</van-tabbar>
</template>
<script>
export default {
	props: {
		active: {
			default: 0
		}
	},
  data() {
    return {
    	activeA: this.active
    };
  },
};
</script>